// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"f9d47aa9","6439":"fa06b3b1"}[chunkId] + ".chunk.css";
};